import { render, staticRenderFns } from "./RegistrationForm.vue?vue&type=template&id=1a2cb20e&scoped=true&"
import script from "./RegistrationForm.vue?vue&type=script&lang=js&"
export * from "./RegistrationForm.vue?vue&type=script&lang=js&"
import style0 from "./RegistrationForm.vue?vue&type=style&index=0&id=1a2cb20e&lang=scss&scoped=true&"
import style1 from "./RegistrationForm.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a2cb20e",
  null
  
)

export default component.exports